"use client";

import { RegisteredComponent } from "@builder.io/sdk-react";
import dynamic from "next/dynamic";

import { commonValidationRules } from "@/libs/builder/common/formFields";
import { withValidation } from "@/libs/builder/validators/validateBuilderComponentData";

export const formCheckboxInputs = [
  {
    name: "id",
    type: "string",
    defaultValue: "sample-id",
    required: true,
  },
  {
    name: "label",
    defaultValue: "Sample checkbox label",
    type: "string",
    required: true,
  },
  {
    name: "isCheckedByDefault",
    type: "boolean",
    defaultValue: false,
  },
  ...commonValidationRules,
] as const satisfies Inputs;

export const FormCheckboxComponent: RegisteredComponent = {
  name: "FormCheckbox",
  component: dynamic(async () =>
    withValidation(
      formCheckboxInputs,
      (await import("./FormCheckbox")).FormCheckbox,
      "FormCheckbox"
    )
  ),
  inputs: formCheckboxInputs,
};
